export default __webpack_public_path__ + "static/media/EM1070.34I-39274_-23306_0.e4e781df.jpg";